import { registerCurrencyServiceAdapters } from '@cubemeet/core/services/currencyService';

let registered = false;

const getConfigValue = (key: string): string | undefined => {
  try {
    // Try window.__CUBEMEET_ENV__ first (generated env.js)
    const win = (typeof window !== 'undefined' ? (window as any) : null);
    if (win && win.__CUBEMEET_ENV__ && typeof win.__CUBEMEET_ENV__ === 'object') {
      const v = win.__CUBEMEET_ENV__[key] || win.__CUBEMEET_ENV__[`VITE_${key}`] || win.__CUBEMEET_ENV__[`VITE_${key.toUpperCase()}`];
      if (typeof v === 'string' && v.length > 0) return v;
    }

    // Then try Vite's injected env (browser/runtime after build)
    try {
      const im: any = (typeof import.meta !== 'undefined' ? (import.meta as any) : undefined);
      const imEnv = im?.env;
      if (imEnv && typeof imEnv === 'object') {
        const v = imEnv[`VITE_${key}`] || imEnv[key] || imEnv[`VITE_${key.toUpperCase()}`];
        if (typeof v === 'string' && v.length > 0) return v;
      }
    } catch (_) {}

    // Fallback to process.env (during SSR/build)
    if (typeof process !== 'undefined' && process.env) {
      return process.env[`VITE_${key}`] || process.env[key];
    }
  } catch (e) {
    // ignore
  }
  return undefined;
};

const ensureRegistered = (): void => {
  if (registered) return;

  registerCurrencyServiceAdapters({
    storage: {
      getItem: async (k: string) => {
        try {
          const v = localStorage.getItem(k);
          return v;
        } catch (e) {
          return null;
        }
      },
      setItem: async (k: string, v: string) => {
        try {
          localStorage.setItem(k, v);
        } catch (e) {
          // ignore
        }
      },
      removeItem: async (k: string) => {
        try {
          localStorage.removeItem(k);
        } catch (e) {
          // ignore
        }
      },
    },
    getLanguage: async () => {
      try {
        // Try a simple navigator lookup
        if (typeof navigator !== 'undefined' && (navigator as any).language) return (navigator as any).language;
      } catch (e) {}
      return undefined;
    },
    getConfigValue: (k: string) => getConfigValue(k),
  });

  registered = true;
};

export default ensureRegistered;
